import React, {memo, useState} from 'react'
import _ from '/home/ps/root'
import vw from '/home/ps/view/view'
import {Fields, cache, Test, equal, copy} from '../../global'
const Anchor = React.lazy(() => import('./part/anchor'))
const Cart =  React.lazy(() => import('./part/cart'))
const JsonDeliver =  React.lazy(() => import('./part/deliver'))
// const JsonMap =  React.lazy(() => import('./part/json-map'))
const Follow =  React.lazy(() => import('./part/follow'))
const Email = React.lazy(() => import('./part/email'))
import Field from './part/field'
import Album from './part/album'
// const Fieldset = React.lazy(() => import('./part/fieldset'))
// const Group, {Fieldset} = React.lazy(() => import('./part/group'))
const Control = React.lazy(() => import('./part/control'))
// const Group =  React.lazy(() => import('./part/group'))
import Group, {Fieldset} from './part/group'
const Table =  React.lazy(() => import('./table'))
const Loading =  React.lazy(() => import('./view/loading'))
// import { usePark } from '../../hook/park'
import Footer from './footer'
const ID = 'body'
const __DEV__ = import.meta.env.__DEV__
export const Body = props => {
  const { db, v } = props
  const { connected, verb: mverb, io, username, login, lang, cookie, u, owner, master, e, route, uri} = props.master
  // const park = { ...props.park }
  const park = props.park
  // const park = props.park
  // const { park, setPark } = usePark()
  const { pk, storeConfig, sell } = props.table
  const { verb: rverb, collapse, cfgRow, stale } = props.row
  const verb = _.Q_.includes(v) ? rverb : mverb
  const printer = park[v][_.Q_.includes(v) ? 'default' : verb]
  const parts = printer.view.part
  const row = park[v][db].default[pk]
  const [ state, _setState ] = useState({
    before: [],
    after: [],
    // printer,
    field: printer.view.field,
    I: printer.part[v].i,
    V: printer.part[v].v,
  })
  const setState = s => _setState(_s => ({..._s, ...s}))
  const { field, I, V } = state
  const bodyProps = {className: [ID, v, `pk${pk}`, verb].concat(stale ? 'stale' : [])}//, onClick: this.onClick.bind(this)}
  bodyProps.className = bodyProps.className.join(' ')
  // if (u==v)
  bodyProps.id = `body${u}${db}${v}${pk}${verb}`
  // const partsCopy = [...parts]
  const control = [], anchor = []
  const controlSet = _control => control.push(_control)
  const anchorSet = _anchor => anchor.push(_anchor)
  const currency = cfgRow ? cfgRow.currency : ''
  const content = parts.reduce((acc, id, i) => {
    const V = printer.part[id].v
    const I = printer.part[id].i
    if (V.t) {
      if (!Test(v, login)) return acc
      const key = `${u}${db}${v}${pk}${verb}${id}`
      const p = {
        ...props,
        v,
        body: {...state, V, I, id, row, extra: ''},
        setBody: setState,
        anchorSet,
        controlSet,
      }
      if (p.deep) p.deep = ++p.deep; else p.deep=1
      switch (V.t) {
      case 'field':
        switch (id) {
        case 'uri': debugger; break
        case 'contact': debugger
        case 'pk': return acc
        case 'json':
if (v=='notice' && row.type == 'purchase' && row.json=='{}') debugger
if (v=='notice' && row.type == 'purchase' && row.json=='[]') debugger
          if (_.CART_.includes(v) || (v=='notice' && row.type == 'purchase')) {
            acc.push(<Cart {...p} key={key}/>);
          } else if (row.type == 'follow' || v == 'follow') {
            acc.push(<Follow {...p} key={key}/>)
          }
          break
        // case _.JSON+_.MAP:
        // case _.MAP:
          // debugger
          // acc.push(<JsonMap {...p}/>)
          // break
        case 'jsondeliver':
          if (connected) return acc
          acc.push(<JsonDeliver {...p} key={key}/>)
          break
          case 'modified':
          case 'lang':
          case 'name':
          if (verb=='default') return acc
          acc.push(<Field {...p} key={key}/>)
          break

        case 'title':
          if (v == 'media' && pk<0) return acc
          if (v=='notice' && pk<0 || verb == 'update' || verb == 'insert') {
            acc.push(<Field {...p} key={key}/>)
            break
          }
          return acc
          // case 'reviews':
          // if (verb=='default') acc.push(<Field {...p} key={key}/>)
          // else return acc
          // break
        case 'desc':
        case 'detail':
          if (p.compact && v != 'review' && p.deep>2) return acc
          acc.push(<Field {...p} key={key}/>)
          break
        case 'medias':
          if (p.row.collapse) return acc
          if (p.ID == 'state') {
            if (p.deep < 5) {
              acc.push(<Field {...p} key={key}/>)
            }
            else return acc
          } else {
            if (v=='menu') acc.push(<Field {...p} key={key}/>); break
            if (p.compact) return acc
          }
          break
        case 'items':
        case 'reviews':
          if (verb=='default') acc.push(<Field {...p} key={key}/>)
          return acc
        case 'from':
          if (collapse || v == 'follows' || v == 'follow') return acc
          default:
          acc.push(<Field {...p} key={key}/>)
          if (id == 'total' && row.total) acc.push(<hr key='hr'/>)
        }
        break
      case 'fieldset':
        if (id == 'service' && verb=='default') return acc
        acc.push(<Fieldset {...p} key={key}/>);
        break
      case 'group':     acc.push(<Group    {...p} key={key}/>); break
      case 'control':  controlSet(<Control  {...p} key={key}/>); /*acc.push(<Control  {...p}/>);*/ break
      case 'anchor':   anchorSet(<Anchor  {...p} key={key}/>); /*acc.push(<Anchor   {...p}/>)*/; break
      case 'button':
        if (id=='otpsend') acc.push(<Email  {...p} key={key}/>)
        else acc.push(<Control  {...p} key={key}/>)
        break
      }
    }
    return acc
  }, [__DEV__ && `${ID}`])
  const _footer = _.CART_.includes(v) || sell&&verb=='default' || v=='notice'&&pk<0 ? false : true
  if (_footer) content.push(<Footer {...props} key={`footer${db}${v}${pk}`}/>)
  content.push(...control)
  content.push(...anchor)
if (control.length) debugger
  return (
    <div
      { ...bodyProps }>
      { [ ...state.before, ...content, ...state.after ] }
      { __DEV__ && `deep ${ props.deep || '0' }` }
    </div>
  )
}
export default Body
